import { Component, OnInit, Input, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, NgForm, Validators, FormControl } from '@angular/forms';
import { ApiServicesService } from '../services/api-services.service';
import { ToastrService } from 'ngx-toastr';
import { MarkCleanFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { Store } from '@ngrx/store';
import { take, takeUntil } from 'rxjs/operators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { LoginService } from 'src/app/modules/login/login.service';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-create-bene-attorney',
  templateUrl: './create-bene-attorney.component.html',
  styleUrls: ['./create-bene-attorney.component.scss']
})

export class CreateBeneAttorneyComponent implements OnInit, AfterViewInit, OnDestroy {
  listCompany;
  closeResult = '';
  formDirty = false;
  inviteBeneForm: FormGroup;
  formChangesSubscription: any;
  isSubmitted = false;
  inviteExternalBeneForm: FormGroup;
  userType:string;
  @Input() public beneficiary;
  @ViewChild('inviteBene', { static: false }) inviteBene: NgForm;
  @ViewChild('popover', { static: false }) popover: ElementRef;
  userIdValidity: boolean;

  public pwd_hide = false;
  observableSubscription$ = new Subject();
  autoGeneratedId : boolean = false;

  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private apiService: ApiServicesService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    protected store: Store<any>, 
    private userService: UserService,
    private loginService: LoginService
    ) {
    this.createForm();
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  private createForm() {
    this.inviteExternalBeneForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      middleName: '',
      communicationEmailId: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit() {
    if (this.userType === "Petitioner") {
      this.inviteExternalBeneForm.addControl('userId', new FormControl(null, Validators.required)); 
    }
  }

  ngAfterViewInit() {
  }

  setUserIdValidity(flag1) {
    this.userIdValidity = flag1;
    if (flag1) {
      this.inviteExternalBeneForm.controls['userId'].setErrors(null);
    }
    else {
      this.inviteExternalBeneForm.controls['userId'].setErrors({ mustMatch: true });
      return false;
    }
  }


  inviteExternalBeneFormSub() {
    if (this.userType === "Petitioner") {
      
      const payload = {
        companyId: parseInt(sessionStorage.getItem('companyId')),
        firstName: this.inviteExternalBeneForm.value.firstName,
        lastName: this.inviteExternalBeneForm.value.lastName,
        middleName: this.inviteExternalBeneForm.value.middleName ? this.inviteExternalBeneForm.value.middleName : '',
        emailId: this.inviteExternalBeneForm.value.communicationEmailId,
        id: 0,
        beneficiaryTypeCode: 'INDVDL',
        userId: this.inviteExternalBeneForm.value.userId,
      };
      // const payload = {  
      //   id:0,
      //   firstName: this.inviteExternalBeneForm.value.firstName,
      //   lastName: this.inviteExternalBeneForm.value.lastName,
      //   middleName: this.inviteExternalBeneForm.value.middleName ? this.inviteExternalBeneForm.value.middleName : '',
      //   emailId: this.inviteExternalBeneForm.value.communicationEmailId,
      //   note: null,
      //   companyId: parseInt(sessionStorage.getItem('companyId')),
      //   userId: this.inviteExternalBeneForm.value.userId,
      //   password: null,
      //   createdBy: 0,
      //   immCategoryCode:null,
      //   beneficiaryId:0,
      //   beneficiaryTypeCode:'INDVDL',
      //   confirmPassword: null,
      //   attorneyCreatePetitioner:true, 
      // }
      this.apiService.sendBeneficiaryInviteByPetitioner(payload)
      .pipe(take(1))
      .subscribe(result => {
        if (result.status === 200) {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
          this.toastr.success(result.message, 'Success');
          this.ref.close();
        } 
        else{
          CustomErrorToastComponent.showErrorToast(this.toastr, result.message) 
          this.ref.close();
        }
      });
    }
    else{
    const payload = {
      companyId: parseInt(sessionStorage.getItem('companyId')),
      firstName: this.inviteExternalBeneForm.value.firstName,
      lastName: this.inviteExternalBeneForm.value.lastName,
      middleName: this.inviteExternalBeneForm.value.middleName ? this.inviteExternalBeneForm.value.middleName : '',
      emailId: this.inviteExternalBeneForm.value.communicationEmailId,
      id: 0,
      beneficiaryTypeCode: 'INDVDL'
    };
    this.apiService.sendBeneficiaryInvite(payload)
      .pipe(take(1))
      .subscribe(result => {
        // console.log(result);
        if (result.status === 200) {
          this.store.dispatch(new MarkCleanFormAction({
            dirty: false
          }));
          this.toastr.success(result.message, 'Success');
          this.ref.close();
        }
      });
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.inviteExternalBeneForm.controls; }

  // IM-3352 (IM-3335) user story done by jeeva 09-10-2020
  closeInviteForm() {

  }

  generateUniqueUsername(popover: any){
    let fullNameArray = [this.inviteExternalBeneForm.get('firstName').value,this.inviteExternalBeneForm.get('lastName').value];

    if((this.inviteExternalBeneForm.get('userId').value && this.userIdValidity) || fullNameArray.length < 2) return;

    
    if(this.inviteExternalBeneForm.get('middleName').value){
      fullNameArray.push(this.inviteExternalBeneForm.get('middleName').value);
    }
    const userId = this.userService.getUserName(fullNameArray);

    this.loginService.checkUserIdAvailability(userId).pipe(takeUntil(this.observableSubscription$)).subscribe((response)=> {
      if(response && response.status === 200){
        if(response.data.available){
          this.autoGeneratedId = true;
          this.inviteExternalBeneForm.get('userId').setValue(userId);
          this.inviteExternalBeneForm.get('userId').markAsDirty();
          this.inviteExternalBeneForm.get('userId').updateValueAndValidity();
          this.setUserIdValidity(true);
          if(popover)
            popover.open();
        }else{
          this.generateUniqueUsername(popover);
        }
      }
    })
  }

  onChangeUserId(){
    this.autoGeneratedId = false;
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
